import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealCashYieldField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          suffix='%'
          onValueChange={handleChange}
          customInput={TextField}
          label='Cash Yield'
          id='cash_yield'
          aria-describedby='cash-yield-helper-text'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />
        {error ? (
          <FormHelperText id='cash-yield-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='cash-yield-helper-text'>
            Enter the projected Cash Yield
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
